// allow: clock-boundary -- Material datepicker adapter reference year
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

import { parseTypedDate } from '@efficiently/client-util-date-time';

const MONTH_INDEX_OFFSET = 1;

/**
 * Date adapter that parses manually typed Month/Day/Year input robustly, replacing the native
 * `Date.parse` fallback that mis-handles short and partial dates (EFF-23638). A bare month
 * (`5`) resolves to the current year instead of 2001, and continuous `MMDDYY` input (`090926`)
 * is parsed as a calendar date instead of being read as a five-digit year.
 */
@Injectable()
export class TypedDateAdapter extends NativeDateAdapter {
	public override parse(value: unknown, parseFormat?: unknown): Date | null {
		if (typeof value !== 'string') {
			return super.parse(value, parseFormat);
		}

		const trimmed = value.trim();

		if (!trimmed) {
			return null;
		}

		const parsed = parseTypedDate(trimmed, { referenceYear: new Date().getFullYear() });

		return parsed ? new Date(parsed.year, parsed.month - MONTH_INDEX_OFFSET, parsed.day) : new Date(Number.NaN);
	}
}
